import { render, staticRenderFns } from "./AddServiceBusiness.vue?vue&type=template&id=48fc7920&scoped=true"
import script from "./AddServiceBusiness.vue?vue&type=script&lang=js"
export * from "./AddServiceBusiness.vue?vue&type=script&lang=js"
import style0 from "./AddServiceBusiness.vue?vue&type=style&index=0&id=48fc7920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc7920",
  null
  
)

export default component.exports